export default __webpack_public_path__ + "static/media/slide_3.6e2ad4f2.png";